import { render, staticRenderFns } from "./ShopHomeLayout.vue?vue&type=template&id=190db378&scoped=true"
import script from "./ShopHomeLayout.vue?vue&type=script&lang=ts"
export * from "./ShopHomeLayout.vue?vue&type=script&lang=ts"
import style0 from "./ShopHomeLayout.vue?vue&type=style&index=0&id=190db378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190db378",
  null
  
)

export default component.exports